<template>
  <div style="height: 100%;margin:0 20px;overflow: hidden">
    <el-row>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_dhga.png"></div>
          <div class="right-msg">
            <div><span>电话呼入</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceDHHR.today }} / {{ serviceDHHR.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceDHHR.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_srhf.png"></div>
          <div class="right-msg">
            <div><span>电话关爱(生日回访)</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceDHGASRHF.today }} / {{ serviceDHGASRHF.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceDHGASRHF.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_jjjy.png"></div>
          <div class="right-msg">
            <div><span>紧急救援</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceJJJY.today }} / {{ serviceJJJY.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceJJJY.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_zxfw.png"></div>
          <div class="right-msg">
            <div><span>咨询服务</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceZXFW.today }} / {{ serviceZXFW.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceZXFW.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_dbdj.png"></div>
          <div class="right-msg">
            <div><span>代办代叫</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceDBDJ.today }} / {{ serviceDBDJ.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceDBDJ.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_fzjy.png"></div>
          <div class="right-msg">
            <div><span>辅助就医</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceFZJY.today }} / {{ serviceFZJY.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceFZJY.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_jjtf.png"></div>
          <div class="right-msg">
            <div><span>居家探访</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceJJTF.today }} / {{ serviceJJTF.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceJJTF.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="order-item">
          <div class="left-icon"><img src="../../../assets/SHscreen/monitor_dlfw.png"></div>
          <div class="right-msg">
            <div><span>代理服务</span></div>
            <div><span style="color: #cccccc;font-size: 12px">当日 / 历史：</span>
              <strong style="color: #00b0c0;font-size: 16px">{{ serviceDLFW.today }} / {{ serviceDLFW.count }}</strong></div>
            <div><span style="color: #cccccc;font-size: 12px">当日完成率：</span><strong style="color: #8bbb5e;font-size: 16px">{{ serviceDLFW.percent }}%</strong></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'leftCenterOrder',
  data () {
    return {
      serviceDHHR: {today: 0, count: 0, percent: 0},
      serviceDHGA: {today: 0, count: 0, percent: 0},
      serviceSRHF: {today: 0, count: 0, percent: 0},
      serviceDHGASRHF: {today: 0, count: 0, percent: 0},
      serviceJJJY: {today: 0, count: 0, percent: 0},
      serviceZXFW: {today: 0, count: 0, percent: 0},
      serviceDBDJ: {today: 0, count: 0, percent: 0},
      serviceFZJY: {today: 0, count: 0, percent: 0},
      serviceJJTF: {today: 0, count: 0, percent: 0},
      serviceDLFW: {today: 0, count: 0, percent: 0}
    }
  },
  created () {
  },
  methods: {
    // 当天服务数量统计
    getTypeTodayVal (arr) {
      // console.log('工单统计1', arr)
      if (arr === null || arr === '') {
        return
      }
      let servicecompletecount = 0
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].servicetype === '电话呼入') {
          this.serviceDHHR.today = arr[i].servicecount
          this.serviceDHHR.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '主动关爱') {
          this.serviceDHGA.today = arr[i].servicecount
          this.serviceDHGA.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
          servicecompletecount = servicecompletecount + arr[i].servicecompletecount
        } else if (arr[i].servicetype === '生日回访') { //
          this.serviceSRHF.today = arr[i].servicecount
          this.serviceSRHF.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
          servicecompletecount = servicecompletecount + arr[i].servicecompletecount
        } else if (arr[i].servicetype === '紧急救援服务') {
          this.serviceJJJY.today = arr[i].servicecount
          this.serviceJJJY.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '咨询服务') {
          this.serviceZXFW.today = arr[i].servicecount
          this.serviceZXFW.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '代办代叫') {
          this.serviceDBDJ.today = arr[i].servicecount
          this.serviceDBDJ.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '辅助就医') {
          this.serviceFZJY.today = arr[i].servicecount
          this.serviceFZJY.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '居家探访') { //
          this.serviceJJTF.today = arr[i].servicecount
          this.serviceJJTF.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        } else if (arr[i].servicetype === '代理服务') {
          this.serviceDLFW.today = arr[i].servicecount
          this.serviceDLFW.percent = arr[i].servicecompletecount === 0 ? 0 : Math.round((arr[i].servicecompletecount / arr[i].servicecount) * 100 * 100) / 100
        }
      }
      this.serviceDHGASRHF.today = this.serviceDHGA.today + this.serviceSRHF.today
      this.serviceDHGASRHF.percent = servicecompletecount === 0 ? 0 : Math.round((servicecompletecount / this.serviceDHGASRHF.today) * 100 * 100) / 100
    },
    // 服务总数统计
    getTypeHistoryVal (arr) {
      // console.log('工单统计2', arr)
      if (arr === null || arr === '') {
        return
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].servicetype === '电话呼入') {
          this.serviceDHHR.count = arr[i].servicecount
        } else if (arr[i].servicetype === '主动关爱') {
          this.serviceDHGA.count = arr[i].servicecount
        } else if (arr[i].servicetype === '生日回访') { //
          this.serviceSRHF.count = arr[i].servicecount
        } else if (arr[i].servicetype === '紧急救援服务') {
          this.serviceJJJY.count = arr[i].servicecount
        } else if (arr[i].servicetype === '咨询服务') {
          this.serviceZXFW.count = arr[i].servicecount
        } else if (arr[i].servicetype === '代办代叫') {
          this.serviceDBDJ.count = arr[i].servicecount
        } else if (arr[i].servicetype === '辅助就医') {
          this.serviceFZJY.count = arr[i].servicecount
        } else if (arr[i].servicetype === '居家探访') { //
          this.serviceJJTF.count = arr[i].servicecount
        } else if (arr[i].servicetype === '代理服务') {
          this.serviceDLFW.count = arr[i].servicecount
        }
      }
      this.serviceDHGASRHF.count = this.serviceDHGA.count + this.serviceSRHF.count
    }
  }
}
</script>

<style scoped>
.order-item{
  height: 56px;
  margin-top: 6px;
}
.left-icon{
  width: 40px;
  height: 43px;
  float: left;
}
.left-icon img{
  width: 40px;
  height: 43px;
}
.right-msg{
  width: calc(100% - 50px);
  margin-left: 10px;
  height: 50px;
  float: left;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/leftCenterOrder.vue